var STR_TO_TOP = 'To top';

$(function () {
    var button = $('<a href="#" id="to-top" class="icon icon-arrowUp text15" title="' + STR_TO_TOP + '"></a>').appendTo('body');

    $(window).scroll(function () {
        if ($(window).scrollTop() > $(window).height())
            button.fadeIn(500);
        else
            button.fadeOut(500);
    });

    button.click(function (e) {
        e.preventDefault();

        $('html, body').animate({ scrollTop: 0 }, 1000, function () {
            window.location.hash = '#';
        });
    });
});